import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53499)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0004 19.5402H0.000488281V9.48271C0.000488281 9.00664 0.386523 8.62061 0.862596 8.62061H49.1384C49.6145 8.62061 50.0005 9.00664 50.0005 9.48271L50.0004 19.5402Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1383 41.3795H0.862596C0.386523 41.3795 0.000488281 40.9934 0.000488281 40.5174V30.46H50.0004V40.5174C50.0004 40.9935 49.6144 41.3795 49.1383 41.3795Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0004 19.54H0.000488281V30.459H50.0004V19.54Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0003 29.6339C22.4452 29.6339 20.3667 27.5554 20.3667 25.0003C20.3667 22.4452 22.4452 20.3667 25.0003 20.3667C27.5554 20.3667 29.6339 22.4452 29.6339 25.0003C29.6339 27.5554 27.5554 29.6339 25.0003 29.6339ZM25.0003 21.2287C22.9204 21.2287 21.2287 22.9204 21.2287 25.0003C21.2287 27.0802 22.9204 28.7719 25.0003 28.7719C27.0802 28.7719 28.7719 27.0802 28.7719 25.0003C28.7719 22.9204 27.0802 21.2287 25.0003 21.2287Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0004 25.5257C25.2905 25.5257 25.5257 25.2905 25.5257 25.0004C25.5257 24.7103 25.2905 24.4751 25.0004 24.4751C24.7103 24.4751 24.4751 24.7103 24.4751 25.0004C24.4751 25.2905 24.7103 25.5257 25.0004 25.5257Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0009 25.079L23.6659 25.2138L20.7983 25.079V24.9214L23.6659 24.7866L25.0009 24.9214V25.079Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.001 25.079L26.3359 25.2138L29.2035 25.079V24.9214L26.3359 24.7866L25.001 24.9214V25.079Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9214 25.0004L24.7866 23.6654L24.9214 20.7979H25.079L25.2138 23.6654L25.079 25.0004H24.9214Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9214 25.0005L24.7866 26.3354L24.9214 29.203H25.079L25.2138 26.3354L25.079 25.0005H24.9214Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9448 25.0561L23.9056 24.2076L21.9731 22.0846L22.0846 21.9731L24.2076 23.9056L25.0561 24.9448L24.9448 25.0561Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9448 25.0562L25.7934 26.0954L27.9164 28.0278L28.0278 27.9164L26.0954 25.7934L25.0562 24.9448L24.9448 25.0562Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9448 24.9448L25.7934 23.9056L27.9164 21.9731L28.0278 22.0846L26.0954 24.2076L25.0562 25.0561L24.9448 24.9448Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9448 24.9448L23.9056 25.7934L21.9731 27.9164L22.0846 28.0278L24.2076 26.0954L25.0561 25.0562L24.9448 24.9448Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0304 25.0734L23.8485 25.7088L21.1478 26.6816L21.0874 26.536L23.6852 25.3142L24.97 24.9277L25.0304 25.0734Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0306 25.0732L26.3154 24.6868L28.9132 23.4649L28.8528 23.3193L26.152 24.2922L24.9702 24.9275L25.0306 25.0732Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9275 25.0304L24.2922 23.8485L23.3193 21.1478L23.4649 21.0874L24.6868 23.6852L25.0732 24.97L24.9275 25.0304Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9277 25.0306L25.3142 26.3154L26.536 28.9132L26.6816 28.8528L25.7088 26.152L25.0734 24.9702L24.9277 25.0306Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.97 25.0732L23.6852 24.6868L21.0874 23.4649L21.1478 23.3193L23.8485 24.2922L25.0304 24.9275L24.97 25.0732Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9702 25.0734L26.152 25.7088L28.8528 26.6816L28.9132 26.536L26.3154 25.3142L25.0306 24.9277L24.9702 25.0734Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9277 24.97L25.3142 23.6852L26.536 21.0874L26.6816 21.1478L25.7088 23.8485L25.0734 25.0304L24.9277 24.97Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9275 24.9702L24.2922 26.152L23.3193 28.8528L23.4649 28.9132L24.6868 26.3154L25.0732 25.0306L24.9275 24.9702Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0006 25.7087C25.3919 25.7087 25.7092 25.3914 25.7092 25.0001C25.7092 24.6088 25.3919 24.2915 25.0006 24.2915C24.6092 24.2915 24.292 24.6088 24.292 25.0001C24.292 25.3914 24.6092 25.7087 25.0006 25.7087Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0006 25.425C25.2353 25.425 25.4255 25.2348 25.4255 25.0001C25.4255 24.7654 25.2353 24.5752 25.0006 24.5752C24.7659 24.5752 24.5757 24.7654 24.5757 25.0001C24.5757 25.2348 24.7659 25.425 25.0006 25.425Z",
					fill: "#41479B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53499",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgInFlag);
export { ForwardRef as ReactComponent };
